import { Location } from '@app/shared/routes';

const SilentRenewLocation = new Location({ path: '/silent-renew' });

export { SilentRenewLocation };
